<div class="header">
  <h2>Modifica <strong>Checklist</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a routerLink="/checklist">Checklist</a></li>
      <li class="active">Modifica Checklist</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-content">
        <form (ngSubmit)="onSubmit()" #loginForm="ngForm" role="form" class="form-horizontal form-validation">
          <div class="form-group">
            <label for="title" class="col-sm-3 control-label">Titolo *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="title"
                     name="title"
                     class="form-control"
                     placeholder="Inserisci Titolo..."
                     minlength="3"
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(name.valid || name.pristine),
                        'form-success': name.valid
                     }"
                     [(ngModel)]="checklist.name"
                     #name="ngModel">
              <i class="icon-check"></i>
              <div [hidden]="name.valid || name.pristine"
                   class="form-error valid">
                Inserisci almeno 3 caratteri.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="description" class="col-sm-3 control-label">Descrizione</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="description"
                     name="description"
                     class="form-control"
                     placeholder="Inserisci Descrizione..."
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(description.valid || description.pristine),
                        'form-success': description.valid
                     }"
                     [(ngModel)]="checklist.description"
                     #description="ngModel">
              <i class="icon-list"></i>
              <div [hidden]="description.valid || description.pristine"
                   class="form-error valid">
                La descrizione è richiesta.
              </div>
            </div>
          </div>

          <div class="text-center m-t-20">
            <button type="submit"
                    class="btn btn-embossed btn-primary"
                    [disabled]="!loginForm.form.valid">
              <i class="icon-pencil"></i> Modifica Checklist</button>
          </div>

          <div [hidden]="checklistUpdateResult" class="alert alert-danger">
            Il Titolo indicato è già presente nel sistema, digitarne un altro.
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

